<script>
import lodash from 'lodash'

export default {
    name: 'ISkeleton',
    functional: true,
    props: {
        active: {
            type: Boolean,
            default: true
        },
        loading: {
            type: Boolean,
            default: true
        },
        avatar: {
            type: [Boolean, Object],
            default: false
        },
        title: {
            type: Boolean,
            default: true
        },
        row: {
            type: [Boolean, String],
            default: '2'
        }
    },
    render(h, ctx) {
        const { avatar, title, row } = ctx.props

        const hasAvatar = !!avatar || avatar === ''
        const hasTitle = !!title
        const hasRow = !!row

        // 渲染头像
        const renderAvatar = avatar => {
            if (!avatar) return null

            let sizeClassName = 'i-skeleton-avatar'
            let iStyle
            if (lodash.isPlainObject(avatar)) {
                sizeClassName +=  `-${avatar.size}` || ''
                iStyle = avatar.style
            }

            return (
                <div class="i-skeleton-header" i-class="pr-16">
                    <span class={['i-skeleton-avatar', sizeClassName]} 
                        i-class="inline-block round"
                        style={iStyle}>
                    </span>
                </div>
            )
        }

        // 渲染标题
        const renderTitle = title => {
            if (!title) return null
            let titleStyle
            if (!hasAvatar && hasRow) {
                titleStyle = { width: '38%' }
            }

            if (hasAvatar && hasRow) {
                titleStyle = { width: '50%' }
            }

            return <h3 class="i-skeleton-title" i-class="mt-12" style={titleStyle}></h3>
        }

        // 渲染行
        const renderRowItem = row => {
            let rowStyle
            let tmpRow

            const tailRow = { width: '61%' }

            // Width
            if (!hasAvatar || !hasTitle) {
                rowStyle = tailRow
            }

            // Rows
            if (!hasAvatar && hasTitle) {
                tmpRow = 3
            } else {
                tmpRow = 2
            }

            const isRowValid = !!+row
            const isRowBoolean = typeof row === 'boolean'
            tmpRow = isRowBoolean ? tmpRow : isRowValid ? +row : tmpRow

            return (
                <ul class="i-skeleton-row" i-class="mt-28">
                    {new Array(tmpRow).fill('').map((li, index) => {
                        let tmpStyle
                        const isLastLi = tmpRow - 1 === index
                        if (isLastLi && tmpRow > 2) tmpStyle = rowStyle || tailRow
                        return <li style={tmpStyle}></li>
                    })}
                </ul>
            )
        }

        return (
            <div class="i-skeleton skeleton" i-class="flex">
                {renderAvatar(avatar)}
                <div class="i-skeleton-content" i-class="spread-1">
                    {renderTitle(title)}
                    {renderRowItem(row)}
                </div>
            </div>
        )
    }
}
</script>

<style scoped lang="scss">
$skeleton-avatar-sm-size: 24px;
$skeleton-avatar-default-size: 32px;
$skeleton-avatar-lg-size: 40px;

%skeleon-item-bg {
    background-color: $skeleton-color;
}

.i-skeleton {
    width: 100%;
}
.i-skeleton-avatar {
    height: $skeleton-avatar-default-size;
    width: $skeleton-avatar-default-size;
    @extend %skeleon-item-bg;

    &-lg {
        height: $skeleton-avatar-sm-size;
        width: $skeleton-avatar-sm-size;
    }
    &-lg {
        height: $skeleton-avatar-lg-size;
        width: $skeleton-avatar-lg-size;
    }
}
.i-skeleton-title {
    width: 50%;
    height: 16px;
    @extend %skeleon-item-bg;
}
.i-skeleton-row > li {
    width: 100%;
    height: 16px;
    @extend %skeleon-item-bg;
    @include brother('li') {
        margin-top: 16px;
    }
}
</style>
